import React from "react";

function FallbackUI() {
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="text-center p-4">
        {/* Illustration style icon */}
        <div className="mb-4">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            fill="currentColor"
            className="bi bi-exclamation-triangle-fill text-warning"
            viewBox="0 0 16 16"
          >
            <path d="M8.982 1.566a1.5 1.5 0 0 0-2.664 0L.165 13.233c-.457.778.091 1.767.998 1.767h13.674c.907 0 1.455-.99.998-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
          </svg>
        </div>

        {/* Headline */}
        <h1 className="fw-bold text-dark mb-3">Something went wrong</h1>
        
        {/* Description */}
        <p className="text-muted mb-4">
          An unexpected error occurred. Don’t worry, you can reload the page and try again.
        </p>

        {/* Reload button */}
        <button
          onClick={handleReload}
          className="btn btn-primary btn-lg px-4 shadow-sm"
        >
          Reload Page
        </button>
      </div>
    </div>
  );
}

export default FallbackUI;
